import { render } from "./foldershare_popup.vue?vue&type=template&id=c3eda07c&scoped=true"
import script from "./foldershare_popup.js?vue&type=script&lang=js"
export * from "./foldershare_popup.js?vue&type=script&lang=js"

import "./foldershare_popup.vue?vue&type=style&index=0&id=c3eda07c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3eda07c"]])

export default __exports__